var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10303",
    "data-name": "Group 10303",
    transform: "translate(-321 -1888)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8691",
    "data-name": "Rectangle 8691",
    width: 56,
    height: 56,
    rx: 28,
    transform: "translate(321 1888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_profile-tick",
    "data-name": "vuesax/outline/profile-tick",
    transform: "translate(29.47 1644.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-tick",
    transform: "translate(300 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.69,7.385a1.207,1.207,0,0,1-.863-.358L.354,4.553A1.22,1.22,0,0,1,2.079,2.828L3.69,4.439,7.775.354A1.22,1.22,0,0,1,9.5,2.079L4.553,7.027A1.207,1.207,0,0,1,3.69,7.385Z",
    transform: "translate(22.285 27.314)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.707,16.877h-.13a.883.883,0,0,0-.293,0A8.411,8.411,0,0,1,0,8.447,8.29,8.29,0,0,1,2.458,2.49a8.436,8.436,0,0,1,14.42,5.957,8.391,8.391,0,0,1-8.121,8.43ZM8.431,2.441A5.991,5.991,0,0,0,8.219,14.42a2.709,2.709,0,0,1,.521,0,5.958,5.958,0,0,0,5.7-5.989A6.019,6.019,0,0,0,8.431,2.441Z",
    transform: "translate(11.083 2.034)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M12.336,16.487A15.984,15.984,0,0,1,3.5,14.029,7.056,7.056,0,0,1,0,8.219,7.022,7.022,0,0,1,3.5,2.441c4.866-3.255,12.776-3.255,17.642,0a1.229,1.229,0,0,1,.342,1.693,1.215,1.215,0,0,1-1.693.342c-4.052-2.7-10.888-2.7-14.94,0A4.653,4.653,0,0,0,2.441,8.219,4.7,4.7,0,0,0,4.85,11.995a13.547,13.547,0,0,0,7.47,2.034,1.229,1.229,0,0,1,.016,2.458Z",
    transform: "translate(7.178 20.23)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H39.06V39.06H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.482b5c8364b3546d92be75d932b42b11.svg";
export { ForwardRef as ReactComponent };